module.exports = __webpack_public_path__ + "img/1481920763.66926bb5.jpg";